export const BUCKET_ASSETS_STATIC_URL = 'https://storage.googleapis.com/chefhero-storage/static/';
export const BUCKET_ASSETS_URL = `${BUCKET_ASSETS_STATIC_URL}fe-buyer/images/`;
